module.exports = __webpack_public_path__ + "img/ZB.bb27aa0b.png";